// extracted by mini-css-extract-plugin
export default {"Reviews":"Reviews_Reviews__RdDzh","Reviews__new":"Reviews_Reviews__new__89jB6","Reviews__table":"Reviews_Reviews__table__mvbBd"};